import { isUnresolvedEdit, useManageRolesStore } from "PFApp/stores/manage_roles";
import { RouterPrompt } from "PFComponents/router_prompt/router_prompt";

type UnsavedEditsRouterPromptProps = {
  onOK: () => Promise<boolean>;
};

export const UnsavedEditsRouterPrompt = ({ onOK }: UnsavedEditsRouterPromptProps) => {
  const hasUnsavedEdits = useManageRolesStore((state) =>
    Object.values(state.unsavedEdits).some((edit) => isUnresolvedEdit(edit, state.newDraftRoles))
  );

  return <RouterPrompt when={hasUnsavedEdits} onOK={onOK} />;
};
